import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import {
  selectMechanicDefaultBranch,
  selectNotDefaultMechanicBranches,
} from "../../../../../redux/auth";
import BranchListItem from "./BranchListItem/BranchListItem";
import classes from "./BranchList.module.css";

const BranchList = (props) => {
  const { onChangeBranch, selectedBranchId } = props;
  const defaultBranch = useSelector(selectMechanicDefaultBranch);
  const branchesExceptDefault = useSelector(selectNotDefaultMechanicBranches);

  return (
    <ul className={classes["branch-list"]}>
      <BranchListItem
        onChange={onChangeBranch}
        checked={defaultBranch.id === selectedBranchId}
        branchName={defaultBranch.name}
        branchId={defaultBranch.id}
      />
      {branchesExceptDefault.map((branch, index) => (
        <BranchListItem
          key={index}
          onChange={onChangeBranch}
          checked={branch.id === selectedBranchId}
          branchName={branch.name}
          branchId={branch.id}
        />
      ))}
    </ul>
  );
};

export default BranchList;

BranchList.propTypes = {
  onChangeBranch: PropTypes.func,
  selectedBranchId: PropTypes.number,
};
